export class NumberHelper {
    ToNumberFixed(param: number, digit: number) {
        return Number(param.toFixed(digit));
    }

    static sanitizePastedMonetaryValue(value: string, maxDecimals: number = 2): string {
        if (!value) {
            return '';
        }

        const str = value.trim().replace(/\./g, '');
        if (!str) {
            return '';
        }

        const commaIndex = str.indexOf(',');
        if (commaIndex !== -1) {
            const integerPart = str.substring(0, commaIndex).replace(/[^\d]/g, '');
            const decimalPart = str.substring(commaIndex + 1).replace(/[^\d]/g, '').substring(0, maxDecimals);
            return decimalPart.length > 0 ? `${integerPart},${decimalPart}` : integerPart;
        }

        return str.replace(/[^\d]/g, '');
    }
}
